export enum ModifierState {
    CAPS_LOCK = 'CapsLock',
    NUM_LOCK = 'NumLock',
}